// Shared tooltip spacing constants used by tooltip components
export const TOOLTIP_GAP = 8; // px distance between anchor and tooltip
